import { styled } from '@mui/material/styles';

export const MarkdownRoot = styled('div', {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'medium' }>(({ theme, size }) => {
  const medium = size === 'medium';
  const fontSize = theme.typography.pxToRem(medium ? 16 : 12);
  const lineHeight = medium ? 1.5 : 1.3;

  return {
    color: theme.palette.textColors?.darkText ?? theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    padding: theme.spacing(0.5, 1),
    '& p': { fontSize, lineHeight, margin: '0.25em 0' },
    '& h1, & h2, & h3': {
      lineHeight: 1.2,
      margin: '0.5em 0 0.25em 0',
      fontWeight: 600,
    },
    '& h1': { fontSize: theme.typography.pxToRem(medium ? 20 : 14) },
    '& h2': { fontSize: theme.typography.pxToRem(medium ? 18 : 13) },
    '& h3': { fontSize: theme.typography.pxToRem(medium ? 16 : 12.5) },
    '& strong': { fontSize, fontWeight: 600 },
    '& em': { fontSize, fontStyle: 'italic' },
    '& a': { fontSize },
    '& code, & pre': {
      fontSize,
      fontFamily: theme.typography.fontFamilyMono ?? 'monospace',
      backgroundColor: theme.palette.action.hover,
      borderRadius: '0.25em',
    },
    '& code': { padding: '0.125em 0.25em' },
    '& pre': { padding: '0.5em', overflow: 'auto' },
    '& ul, & ol': { fontSize, lineHeight, margin: '0.25em 0', paddingLeft: '1.2em' },
    '& li': { fontSize, lineHeight, margin: '0.125em 0' },
    '& blockquote': {
      fontSize,
      borderLeft: `2px solid ${theme.palette.divider}`,
      paddingLeft: '0.5em',
      margin: '0.25em 0',
      fontStyle: 'italic',
    },
  };
});
